import { Injectable } from '@angular/core';
import { ColorService } from '@services/color/color.service';

@Injectable({
    providedIn: 'root',
})
export class ChartColorService {
    public session = [
        this._colorService.getColor('green'),
        this._colorService.getColor('blue'),
        this._colorService.getColor('grey'),
        this._colorService.getColor('red'),
    ];

    public jobs = [
        this._colorService.getColor('green'),
        this._colorService.getColor('red'),
        this._colorService.getColor('orange'),
    ];

    public transactions = [
        this._colorService.getColor('blue'),
        this._colorService.getColor('orange'),
        this._colorService.getColor('red'),
        this._colorService.getColor('green'),
    ];

    public license = [
        this._colorService.getColor('green'),
        this._colorService.getColor('orange'),
        this._colorService.getColor('red'),
        this._colorService.getColor('blue'),
        this._colorService.getColor('orangeDark'),
    ];

    constructor(private _colorService: ColorService) { }
}
